import React from "react";
import { observer } from "owa-mobx-react";
import { nodeCountSingularScreenReaderOnlyText, nodeCountPluralScreenReaderOnlyText, } from "./UnreadReadCountBadge.locstring.json";
import { unreadCountScreenReaderOnlyText } from "owa-locstrings/lib/strings/unreadcountscreenreaderonlytext.locstring.json";
import loc from "owa-localize";
import { getDensityModeCssClass } from "owa-fabric-theme";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";

export interface UnreadReadCountBadgeProps extends React.HTMLProps<HTMLDivElement> {
    count: number | string;
    shouldDisplayTotalCount?: boolean;
    screenReaderText?: string;
    customStyle?: string;
    isListViewBadge?: boolean;
}
import { full, medium, compact, listViewBadge, unreadOrTotalCount, unreadCount, totalCount, unreadOrTotalCountOrUnreadCount_Win32Style, totalCount_Win32Style, totalCountBadge, plainBadge, } from "./UnreadReadCountBadge.scss";

import classnames from "owa-classnames";

const defaultExport: React.FunctionComponent<UnreadReadCountBadgeProps> = observer(function UnreadReadCountBadge(props: UnreadReadCountBadgeProps) {
    const { count, shouldDisplayTotalCount, screenReaderText, customStyle, isListViewBadge } = props;
    const isDenselessEnabled = isGlobalFeatureEnabled("mon-type-ramp");
    const densityMode = isDenselessEnabled
        ? compact
        : getDensityModeCssClass(full, medium, compact);
    
    const isWin32Style = isWin32StylingEnabled();
    const countContainerClassNames = classnames(customStyle, isListViewBadge && listViewBadge, unreadOrTotalCount, isWin32Style && unreadOrTotalCountOrUnreadCount_Win32Style, !shouldDisplayTotalCount && unreadCount, !shouldDisplayTotalCount && isWin32Style && unreadOrTotalCountOrUnreadCount_Win32Style, shouldDisplayTotalCount && totalCount, shouldDisplayTotalCount && isWin32Style && totalCount_Win32Style, densityMode);
    return count ? (<span className={countContainerClassNames}>
                <span className={classnames(densityMode, plainBadge, shouldDisplayTotalCount && totalCountBadge)}>
                    {shouldDisplayTotalCount ? `[${count}]` : count}
                </span>
                <span className="screenReaderOnly">
                    {
        // for a treeitem, inner content that have aria-hidden=true are not hidden in IE
        // therefore we cannot hide the visual string and use a screenReaderOnly string that has the count
        screenReaderText || shouldDisplayTotalCount
            ? count == 1
                ? loc(nodeCountSingularScreenReaderOnlyText)
                : loc(nodeCountPluralScreenReaderOnlyText)
            : loc(unreadCountScreenReaderOnlyText)}
                </span>
            </span>) : null;
}, "UnreadReadCountBadge");
export default defaultExport;
